import { defineFormConfig } from "@src/components/business-form";
import type { StockGatheringCompleteReserveParams } from "../../../../../../api/stockGatherings";

/** Значения формы комплектования резерва КВ. */
export interface StockGatheringCompletionReserveFormValues {
    /** Собранное количество резерва. */
    qty: number;
}

/** Контекст формы комплектования резерва КВ. */
export interface StockGatheringCompletionReserveFormContext {
    /** Код КВ. */
    gatheringCode: number;
    /** Код строки состава КВ. */
    gatheringContCode: number;
    /** Код резерва. */
    reserveCode: number;
    /** Код партии резерва. */
    lotCode: number;
}

/** Конфигурация формы комплектования резерва КВ. */
export const stockGatheringCompletionReserveFormConfig = defineFormConfig<
    StockGatheringCompletionReserveFormValues,
    StockGatheringCompleteReserveParams,
    StockGatheringCompletionReserveFormContext
>({
    fields: {
        qty: {
            type: "number",
            label: "Количество собранного",
            validation: { required: true, positive: true },
            map: {
                from: (domain) => domain.qty,
                to: (value, _values, ctx) => ({
                    gatheringCode: ctx?.gatheringCode ?? 0,
                    gatheringContCode: ctx?.gatheringContCode ?? 0,
                    reserveCode: ctx?.reserveCode ?? 0,
                    lotCode: ctx?.lotCode ?? 0,
                    qty: value,
                }),
            },
        },
    },
});
